






















import Vue from 'vue';
import { BButton } from 'bootstrap-vue';
import { Button } from './types';
import { putRequest } from '../../utils/client/client';

export default Vue.extend({
  name: 'ObjectStatusTransition',
  components: { BButton },
  props: {
    url: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    nextBtn: {
      type: Object,
      default: null,
    },
    prevBtn: {
      type: Object,
      default: null,
    },
    inDropdown: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async changeState(btn: Button) {
      try {
        await putRequest({
          url: this.url,
          data: { new_status: btn.status },
          headers: { 'X-CSRF-Token': this.csrfToken },
        });

        this.showSuccessMsg(btn.msg_success);
        if (this.nextBtn.redirect_url) {
          window.location.href = this.nextBtn.redirect_url;
        } else {
          this.reload();
        }
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: 'Oops, something went wrong. Please try ' + 'again or refresh your page.',
        });
      }
    },
    showSuccessMsg(message: string) {
      if (window.GGRC.zenModal.visible) {
        window.GGRC.Notify({
          type: 'success',
          message,
        });
      } else {
        window.GGRC.NotifyNextLoad({
          type: 'success',
          message,
        });
      }
    },
    reload() {
      if (window.GGRC.zenModal.visible) {
        window.GGRC.zenModal.$emit('reload');
      } else {
        window.location.reload();
      }
    },
  },
});
